import React from 'react';
import { Box, Heading, Button, SimpleGrid, VStack, Image, Input, useToast } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import PhotoGrid from "../components/Admin/PhotoGrid";

const Admin: React.FC = () => {
    const toast = useToast();
    const navigate = useNavigate();

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const file = event.target.files?.[0];
        if (!file) return;
        const url = URL.createObjectURL(file);
        toast({ title: `Photo ${index + 1} mise à jour`, status: 'success', duration: 2000 });
    };

    return (
        <Box p={6} maxW="6xl" mx="auto">
            <Heading mb={4}>Tableau de bord Admin</Heading>

            <Button mb={6} colorScheme="blue" variant="outline" onClick={() => navigate('/') }>
                Retour au site
            </Button>

            <PhotoGrid/>

        </Box>
    );
};

export default Admin;
